export const CustomDisclaimerModalTranslations = {
  en: {
    customDisclaimerModal: {
      title: "Custom System",
      cancel: "Cancel",
      accept: "Accept",
    },
  },
  es: {
    customDisclaimerModal: {
      title: "Sistema personalizado",
      cancel: "Cancelar",
      accept: "Aceptar",
    },
  },
};
